function setLangeModuleTitle(fallback){const title=window.LANGE_NATIVE_SEO?.title||fallback;if(document.title!==title)document.title=title;}
import { isSetEligible } from "./_lange-catalogue--set-builder-core.js";
import { header, footer, bindHeader, CONCERNS, CONCERN_PATH } from "./_lange-catalogue--chrome.js";
import { mountSetBar } from "./_lange-catalogue--set-builder-bar.js";
import { mobilePhoto } from "./_lange-catalogue--responsive-images.js";
import { SHOP_PATH, BUILDER_PATH, TIERS, loadCatalogue, isSelected, toggleProduct, onSelectionChange, getSelection, MAX_ITEMS, formatPrice, escapeHtml, productImage, productPath, hasLocalPackshot, productArtless } from "./_lange-catalogue--set-builder-core.js";
const COPY = {
  'fine-lines': {
    eyebrow: "Fine lines & firmness",
    title: "Smoother-looking skin.<br><em>A fresher-looking Face.</em>",
    lede: "Target the look of fine lines and loss of firmness with Serums and creams that hydrate, nourish and leave skin feeling softer. Find the formula for the changes you want to see.",
    image: '/lange/paris/editorial/portrait-fine-lines-1600.webp',
    note: "Choose a Serum for a lightweight layer of care, then a cream to replenish moisture. Explore each formula for its ingredients, benefits and application."
  },
  'eye-area': {
    eyebrow: "The Eye area",
    title: "A fresher look,<br><em>starting with your Eyes.</em>",
    lede: "Discover targeted care for fine lines, dryness and a tired-looking Eye area. Choose from eye creams, Serums and masks to nourish this delicate skin and soften the look of early lines.",
    image: '/lange/paris/editorial/eye-ritual-1400.webp',
    note: "Compare the textures and benefits to find your Eye care, from a daily cream to a nourishing mask."
  },
  hydration: {
    eyebrow: "Dryness & hydration",
    title: "Replenish moisture.<br><em>Rediscover softer skin.</em>",
    lede: "When skin feels tight or looks dry, give it the moisture it needs. Explore hydrating Serums and nourishing creams for a softer, smoother-looking Face and a supple feel.",
    image: '/lange/paris/editorial/formula-texture-1400.webp',
    note: "Layer a hydrating Serum beneath your cream, or choose a richer texture when skin needs extra nourishment."
  },
  comfort: {
    eyebrow: "Nourishment & softness",
    title: "Nourish dry skin.<br><em>Bring back its softness.</em>",
    lede: "Give dry, rough-feeling skin a richer daily ritual. Explore nourishing textures that replenish moisture and leave your Face feeling soft and supple.",
    image: '/lange/paris/editorial/night-application-1100.webp',
    note: "These formulas contain fragrance. Check the full ingredient list before choosing if your skin is sensitive to fragrance or a particular ingredient."
  },
  radiance: {
    eyebrow: "Dullness & radiance",
    title: "From dull-looking<br><em>to fresh-faced.</em>",
    lede: "Bring a fresh glow to skin that looks dull or tired. Explore care that replenishes moisture and smooths the look of skin, revealing a more radiant-looking Face.",
    image: '/lange/paris/editorial/portrait-limestone-1600.webp',
    note: "Explore each formula to find the texture and daily care that suit your skin, from a lightweight Serum to a nourishing cream."
  }
};
const state = {
  products: [],
  concern: null,
  slug: null
};
function card(product) {
  const selected = isSelected(product.slug);
  const full = getSelection().length >= MAX_ITEMS && !selected;
  const brief = product.officialBrief ?? {};
  const result = (brief.consumerResults ?? [])[0];
  return `
    <article class="lcn-card${selected ? ' is-selected' : ''}">
      <a class="lcn-card__image" href="${productPath(product)}" tabindex="-1" aria-hidden="true">
        ${product.inStock === false ? '<span class="lc-popular-ribbon">Out of stock</span>' : ['Carat', 'Collagen Booster', 'Anti-Ageing'].includes(product.officialBrief?.line ?? product.category) ? '<span class="lc-popular-ribbon">Popular</span>' : ''}
        ${hasLocalPackshot(product) ? `<img src="${productImage(product, 720)}" alt="" loading="lazy" decoding="async"
              data-fallback="${escapeHtml(product.image || '')}">` : productArtless(product)}
      </a>
      <div class="lcn-card__body">
        <p class="lcn-card__role">${escapeHtml(product.role)}</p>
        <h3><a href="${productPath(product)}">${escapeHtml(product.name)}</a></h3>
        <p class="lcn-card__benefit">${escapeHtml(product.commercialBenefits?.concern ?? brief.shortBenefit ?? product.benefitHeadline ?? '')}</p>
        ${result ? `<p class="lcn-card__proof"><strong>${escapeHtml(result.percentage)}</strong> ${escapeHtml(result.statement)}<small> · 20 women, 3-week self-assessment</small></p>` : ''}
        <div class="lcn-card__foot">
          <span>${formatPrice(product.price)}</span>
          ${isSetEligible(product) ? `<button type="button" data-set-toggle="${escapeHtml(product.slug)}" ${full || product.inStock === false ? 'disabled' : ''} aria-pressed="${selected}">
            ${product.inStock === false ? 'Out of stock' : selected ? 'In your set ✓' : full ? `Set holds ${MAX_ITEMS}` : 'Add to set'}
          </button>` : `<a class="lc-individual-link" href="${productPath(product)}">Shop individually →</a>`}
        </div>
      </div>
    </article>`;
}
function siblings(currentSlug) {
  return CONCERNS.filter(c => c.slug !== currentSlug).map(c => `<a href="${CONCERN_PATH}/${c.slug}/">${escapeHtml(c.label)}</a>`).join('');
}
function page(copy, products) {
  return `<div class="lc-site lcn-site">
    ${header({
    current: 'shop'
  })}
    <main>
      <section class="lcn-hero">
        ${mobilePhoto(copy.image, 'class="lcn-hero__bg" alt="" aria-hidden="true" fetchpriority="high" decoding="async"')}
        <div class="lcn-hero__copy">
          <p class="lcn-kicker">${escapeHtml(copy.eyebrow)}</p>
          <h1>${copy.title}</h1>
          <p class="lcn-hero__lede">${escapeHtml(copy.lede)}</p>
          <p class="lcn-hero__count"><strong>${products.length}</strong> ${products.length === 1 ? 'formula' : 'formulas'} · any 2 for ${formatPrice(TIERS[0].price)}, any 3 for ${formatPrice(TIERS[1].price)}</p>
        </div>
      </section>

      <section class="lcn-grid-wrap">
        <div class="lcn-grid">${products.map(card).join('')}</div>
        <p class="lcn-note">${escapeHtml(copy.note)}</p>
      </section>

      <section class="lcn-siblings">
        <p class="lcn-kicker">Other concerns</p>
        <div>${siblings(state.slug)}</div>
        <a class="lcn-siblings__all" href="${SHOP_PATH}">See all 35 formulas <span aria-hidden="true">→</span></a>
      </section>

      <section class="lpg-cta">
        <div>
          <h2>Two formulas, ${formatPrice(TIERS[0].price)}</h2>
          <p>Choose two eligible formulas for €89 or three for €119. Build your routine around what your skin needs.</p>
        </div>
        <a href="${BUILDER_PATH}">Build your set <span aria-hidden="true">→</span></a>
      </section>
    </main>
    ${footer()}
  </div>`;
}
function wireCards() {
  document.querySelectorAll('img[data-fallback]').forEach(img => {
    img.addEventListener('error', () => {
      const fallback = img.dataset.fallback;
      if (fallback && img.src !== fallback) {
        img.src = window.langeResolve(fallback);
        return;
      }
      img.style.visibility = 'hidden';
    });
  });
  document.querySelectorAll('[data-set-toggle]').forEach(button => {
    button.addEventListener('click', () => toggleProduct(button.dataset.setToggle));
  });
}
function render() {
  const copy = COPY[state.slug];
  const products = state.products.filter(p => p.concern === state.concern);
  const target = document.getElementById('lange-catalogue-root');
  target.innerHTML = window.langeResolve(page(copy, products));
  bindHeader();
  wireCards();
}
async function start() {
  const app = document.getElementById('root');
  if (app) app.hidden = true;
  // Keep native initial markup and live event binding on the same root.
  const nativeInitial = document.querySelector('script[data-lange-native-locale]');
  const target = (nativeInitial && document.getElementById('lange-catalogue-root')) || document.createElement('div');
  target.id = 'lange-catalogue-root';
  if (!target.isConnected) document.body.append(target);
  state.slug = window.LANGE_ROUTE.replace(/\/$/, '').split('/').pop();
  const entry = CONCERNS.find(c => c.slug === state.slug);
  document.documentElement.lang = 'en';
  if (!entry || !COPY[state.slug]) {
    target.innerHTML = window.langeResolve(`<div class="lc-site lcn-site">${header()}<main><section class="lcn-hero lcn-hero--plain"><div class="lcn-hero__copy"><h1>Concern not found</h1><p class="lcn-hero__lede"><a href="${SHOP_PATH}">See THE COLLECTION - ONLINE EXCLUSIVE OFFERS</a></p></div></section></main>${footer()}</div>`);
    bindHeader();
    return;
  }
  state.concern = entry.concern;
  state.products = await loadCatalogue();
  const title = `${entry.label} | LANGÉ PARIS`;
  setLangeModuleTitle(title);
  render();
  window.setTimeout(() => {
    setLangeModuleTitle(title);
  }, 650);
  onSelectionChange(() => render());
  mountSetBar({
    alwaysVisible: false
  });
}
start();